module.exports = "<div>\n  <div>\n    <h3>Lo sentimos</h3>\n    <p>{{ data.reason }}</p>\n    <p>Status: {{ data.status }}</p>\n  </div>\n</div>\n"